<template>
  <div id="tf-hubpartners" class="text-center">
    <div class="section-title text-center center">
      <h2>
        {{ $t("home.partners1") }}<strong> {{ $t("home.partners2") }}</strong>
      </h2>
      <div class="line">
        <hr />
      </div>
    </div>
    <div class="flexbox" @click="offical">
      <img :src="imgsUrl[0]" alt="" height="100" />
      <img :src="imgsUrl[1]" alt="" height="100" />
      <img :src="imgsUrl[2]" alt="" height="100" />
      <img :src="imgsUrl[3]" alt="" height="100" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const imgsUrl = ref([
  require("@/assets/img/hub/Three.png"),
  require("@/assets/img/hub/Sino.png"),
  require("@/assets/img/hub/Crrc.png"),
  require("@/assets/img/hub/Sdlg.png"),
]);

const offical = () => {
  const url = "https://www.bodor.cn/clientCase-home/";
  window.open(url, "_blank");
};
</script>

<style scoped>
#tf-hubpartners {
  background: url("@/assets/img/parteners.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  color: #ffffff;
  padding: 80px 0;
}
.flexbox {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .flexbox {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
  }
  img {
    margin-top: 50px;
  }
}
</style>
